<template lang="html">


<div></div>


</template>

<script lang="js">
  export default  {
    name: 'error-404',
    props: [],
  }
</script>

<style scoped lang="scss">
  .error-404 {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/error-404.vue